import { views } from './constants';
import defaultFormats from '../formats';
import localizer from '../localizer';

import VIEWS from '../Views';

const Formats = {
  [views.MONTH]: 'monthHeaderFormat',
  [views.WEEK]: 'dayRangeHeaderFormat',
  [views.DAY]: 'dayHeaderFormat',
  [views.AGENDA]: 'agendaHeaderFormat',
};

export default function viewLabel(date, view, _formats, culture) {
  const View = VIEWS[view];
  const headerSingle = view === views.MONTH || view === views.DAY;
  const formats = defaultFormats(_formats || {});

  const headerFormat = formats[Formats[view]];

  return headerSingle
    ? localizer.format(date, headerFormat, culture)
    : localizer.format(View.range(date, { culture }), headerFormat, culture);
}
